import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
  HOUSEHOLD_STATUS_ACTIVE,
} from 'common/householdConstants';

import {
  APPLICATION_FORM_TYPE_RENTER_PREQUAL,
} from 'common/householdApplication/applicationFormFields';

import branch from 'client/core/branch';
import HouseholdActions from 'client/actions/Household';

@branch({
  currentUserId: ['currentUser', 'id'],
  householdApplications: ['householdApplications'],
  renterProfilesByUserId: ['household', 'renterProfilesByUserId'],
})
class SrContinueApplicationButton extends Component {
  static propTypes = {
    currentUserId: PropTypes.number.isRequired,
    householdApplications: PropTypes.array,
    renterProfilesByUserId: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { currentUserId, dispatch } = this.props;
    dispatch(HouseholdActions.loadRenterProfile, { userId: currentUserId });
  }

  _getSrHouseholdApplications() {
    const { householdApplications } = this.props;
    return (householdApplications || [])
      .filter(({ isOnlineApp }) => !isOnlineApp);
  }

  _onContinueApplication = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const {
      dispatch,
    } = this.props;

    const hasStartedPrequal = this._checkIfHasStartedPrequal();

    const incompleteHouseholdApplication = this._getSrHouseholdApplications()
      .find((householdApplication) => {
        return (
          householdApplication.status === HOUSEHOLD_APPLICATION_STATUS_STARTED
          && householdApplication.householdStatus === HOUSEHOLD_STATUS_ACTIVE
        );
      });

    if (incompleteHouseholdApplication) {
      dispatch(HouseholdActions.startApplication, {
        listingId: incompleteHouseholdApplication.listingId,
      });
    }
    else if (hasStartedPrequal) {
      dispatch(HouseholdActions.redirectToApplicationForm, {
        formType: APPLICATION_FORM_TYPE_RENTER_PREQUAL,
      });
    }
  }

  _checkIfHasStartedPrequal = () => {
    const {
      currentUserId,
      renterProfilesByUserId,
    } = this.props;

    const renterProfile = renterProfilesByUserId[currentUserId];

    const hasStartedPrequal = (
      renterProfile
      && renterProfile.hasStartedPrequal
      && !renterProfile.isPrequalCompleted
    );

    return hasStartedPrequal;
  }

  render() {
    const hasStartedPrequal = this._checkIfHasStartedPrequal();
    const hasStartedApplication = this._getSrHouseholdApplications()
      .some((householdApplication) => {
        return householdApplication.status === HOUSEHOLD_APPLICATION_STATUS_STARTED
          && householdApplication.householdStatus === HOUSEHOLD_STATUS_ACTIVE;
      });

    if (!hasStartedApplication && !hasStartedPrequal) {
      return null;
    }

    return (
      <span onClick={this._onContinueApplication}>
        <span className='bannerStripe'>
          <span className='text'>
            {hasStartedApplication
              ? 'continue application'
              : 'complete quiz'
            }
          </span>
        </span>
      </span>
    );
  }
}

SrContinueApplicationButton.displayName = 'SrContinueApplicationButton';

export default SrContinueApplicationButton;
